import React, { useState, useEffect } from "react";
import { Card, CardContent, CardHeader } from "@mui/material";

import MappingToolBar from "../../../../components/MappingToolbar";
import MapTenantModal from "./MapTenantModal";
import { useDialog } from "../../../../contexts/DialogContext";
import { getTimeStamp } from "../../../../utils/common";
import MappedTenant from "./MappedTenant";

const AllowedTenant = ({ planId }) => {
  const { openDialog } = useDialog();

  const openDownloadDialog = () => {
    return openDialog(
      "mapping_tenant",
      "Mapping Tenant",
      <MapTenantModal planId={planId} key={getTimeStamp()} />,
    );
  };

  return (
    <Card mb={6}>
      <CardHeader action={<MappingToolBar openDialog={openDownloadDialog} />} />
      <CardContent>
        <MappedTenant planId={planId} />
      </CardContent>
    </Card>
  );
};

export default AllowedTenant;
